import React from 'react';
import { Helmet } from 'react-helmet-async';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="notfound-page">
      <Helmet>
        <title>Pagina nao encontrada — LibbenIncorp</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="notfound-inner">
        <span className="notfound-code">404</span>
        <h1 className="notfound-title">Pagina nao encontrada</h1>
        <p className="notfound-text">A pagina que voce procura nao existe ou foi movida.</p>
        <a href="/" className="notfound-cta">Voltar ao inicio</a>
      </div>
    </div>
  );
}
